import type { Metric } from 'web-vitals';

type ReportHandler = (metric: Metric) => void;

export const initWebVitals = async (onReport: ReportHandler) => {
  const { onCLS, onFID, onLCP, onINP, onTTFB, onFCP } = await import('web-vitals');
  onCLS(onReport);
  onFID(onReport);
  onLCP(onReport);
  onINP(onReport);
  onTTFB(onReport);
  onFCP(onReport);
};

export default initWebVitals;


